// import { FaAngleRight } from "react-icons/fa";

import TableRow from "./TableRow";
import { row_details } from "./TableRowInfo";

const EventProgram = () => {
  return (
    <table>
      <thead>
        <tr className="sub-caption">
          <th>Saat</th>
          <th>10 EKİM CUMARTESİ</th>
          <th>Saat</th>
          <th>11 EKİM PAZAR</th>
        </tr>
      </thead>
      <tbody>
        {row_details.map((row_detail, index) => (
          <TableRow
            key={`tablerow_${index}`}
            first_time={row_detail.first_time}
            first_hour={row_detail.first_hour}
            first_lesson={row_detail.first_lesson}
            first_lecturer={row_detail.first_lecturer}
            first_topic={row_detail.first_topic}
            first_detail={row_detail.first_detail}
            second_time={row_detail.second_time}
            second_hour={row_detail.second_hour}
            second_lesson={row_detail.second_lesson}
            second_lecturer={row_detail.second_lecturer}
            second_topic={row_detail.second_topic}
            second_detail={row_detail.second_detail}
          />
        ))}
        <tr>
          <td colSpan={2}>Toplam Ders Sayısı = 8</td>
          <td colSpan={2}>Toplam Ders Sayısı = 7</td>
        </tr>

        {/* <tr>
                    <td rowSpan={4} className="long-column">
                        <span className="lecture-time">08:00 - 08:45</span>
                        <br />
                        <span className="lecture-hour-count">Ders Saati: 1</span>
                    </td>
                    <td className="lecture-name">Ders Adı: 6283 Sayılı Hemşirelik Kanunu</td>
                    <td rowSpan={4} className="long-column">
                        <span className="lecture-time">08:00 - 08:45</span>
                        <br />
                        <span className="lecture-hour-count">Ders Saati: 1</span>
                    </td>
                    <td className="lecture-name">Ders Adı: 5237 sayılı Türk Ceza Kanunu</td>
                </tr>
                <tr>
                    <td>
                        <p>
                            <strong>Ders Verecek Öğretim Üyesi:</strong> Prof. Dr. Ülkü BAYKAL
                        </p>
                    </td>
                    <td>
                        <p>
                            <strong>Ders Verecek Öğretim Üyesi:</strong> Doç. Dr. Hüsnü Sefa ERYILDIZ 
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>
                            <strong>Ders Konusu:</strong> Hemşirelik Kanunu kapsamında hemşirenin rol ve sorumlulukları
                        </p>
                    </td>
                    <td>
                        <p>
                            <strong>Ders Konusu:</strong> Hemşireleri ilgilendiren 5237 sayılı Türk Ceza Kanunu Maddeleri 
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>
                            <strong>Detaylı Ders İçeriği:</strong>
                            Hemşirelik Kanununun amacı, kapsamı nedir? / Hemşirelik Hizmetlerinin Kapsamı nedir? /Hemşirelik Kanuna göre hemşire kime denir? Hemşirelerin görev yetki ve sorumlukları nelerdir? Yetki belgesine sahip hemşire, uzman hemşirenin kime denir? /Yönetimde rüçhan hak kavramı nedir? / Hemşirelik Hizmetlerinin Yönetimi ve Organizasyonu/Tarihsel süreçte hemşirelik kanununda yapılan değişikler nelerdir?
                        </p>
                    </td>
                    <td>
                        <p>
                            <strong>Detaylı Ders İçeriği:</strong>
                            Türk Ceza Kanunun Amacı /Suçta ve Cezada Kanunilik ilkesinin tanımı/Adalet ve Kanun Önünde Eşitlik ilkesinin tanımı/Kanunun Bağlayıcılığının tanımı/ Ceza Sorumluluğunun şahsiliği nedir?/ Kast/Olası Kast Taksir/Bilinçli Taksir nedir? 5237 sayılı TCK‟daki sağlık personelleriyle ilgili taksirli suçlar nelerdir? 5237 sayılı TCK’ da sağlık personelini ilgilendirenler netice sebebiyle ağırlaşmış şuçlar nelerdir?
                        </p>
                    </td>
                </tr> */}

        {/* <tr>
                    <td rowSpan={3} className="long-column">
                        <span className="lecture-no">1. DERS</span>
                        <br />
                        <span className="lecture-time">09:00 - 09:45</span>
                        <br />
                        <span className="lecture-hour-count">Ders Saati: 1</span>
                    </td>
                    <td className="lecture-name">Ders Adı: Öğrenci Danışman İlişki Süreci</td>
                    <td rowSpan={3} className="long-column">
                        <span className="lecture-no">1. DERS</span>
                        <br />
                        <span className="lecture-time">09:00 - 09:45</span>
                        <br />
                        <span className="lecture-hour-count">Ders Saati: 1</span>
                    </td>
                    <td className="lecture-name">Ders Adı: Öğrenci Danışman İlişki Süreci</td>
                </tr>
                <tr>
                    <td className="lecturer-name">Ders Verecek Öğretim Üyesi: Prof. Dr. Mustafa SÖZBİLİR</td>
                    <td className="lecturer-name">Ders Verecek Öğretim Üyesi: Arş. Gör. Osman DURDAĞ</td>
                </tr>
                <tr>
                    <td>
                        <ul>
                            <strong>Detaylı Ders İçeriği:</strong>
                            <li><FaAngleRight /> İyi bir ilişki için temel kurallar</li>
                            <li><FaAngleRight /> İletişimde engellerin kaldırılması</li>
                        </ul>
                    </td>
                    <td>
                        <ul>
                            <strong>Detaylı Ders İçeriği:</strong>
                            <li><FaAngleRight /> İyi bir ilişki için temel kurallar</li>
                            <li><FaAngleRight /> İletişimde engellerin kaldırılması</li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td rowSpan={3} className="long-column">
                        <span className="lecture-no">1. DERS</span>
                        <br />
                        <span className="lecture-time">09:00 - 09:45</span>
                        <br />
                        <span className="lecture-hour-count">Ders Saati: 1</span>
                    </td>
                    <td className="lecture-name">Ders Adı: Öğrenci Danışman İlişki Süreci</td>
                    <td rowSpan={3} className="long-column">
                        <span className="lecture-no">1. DERS</span>
                        <br />
                        <span className="lecture-time">09:00 - 09:45</span>
                        <br />
                        <span className="lecture-hour-count">Ders Saati: 1</span>
                    </td>
                    <td className="lecture-name">Ders Adı: Öğrenci Danışman İlişki Süreci</td>
                </tr>
                <tr>
                    <td className="lecturer-name">Ders Verecek Öğretim Üyesi: Prof. Dr. Mustafa SÖZBİLİR</td>
                    <td className="lecturer-name">Ders Verecek Öğretim Üyesi: Arş. Gör. Osman DURDAĞ</td>
                </tr>
                <tr>
                    <td>
                        <ul>
                            <strong>Detaylı Ders İçeriği:</strong>
                            <li><FaAngleRight /> İyi bir ilişki için temel kurallar</li>
                            <li><FaAngleRight /> İletişimde engellerin kaldırılması</li>
                        </ul>
                    </td>
                    <td>
                        <ul>
                            <strong>Detaylı Ders İçeriği:</strong>
                            <li><FaAngleRight /> İyi bir ilişki için temel kurallar</li>
                            <li><FaAngleRight /> İletişimde engellerin kaldırılması</li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td rowSpan={3} className="long-column">
                        <span className="lecture-no">1. DERS</span>
                        <br />
                        <span className="lecture-time">09:00 - 09:45</span>
                        <br />
                        <span className="lecture-hour-count">Ders Saati: 1</span>
                    </td>
                    <td className="lecture-name">Ders Adı: Öğrenci Danışman İlişki Süreci</td>
                    <td rowSpan={3} className="long-column">
                        <span className="lecture-no">1. DERS</span>
                        <br />
                        <span className="lecture-time">09:00 - 09:45</span>
                        <br />
                        <span className="lecture-hour-count">Ders Saati: 1</span>
                    </td>
                    <td className="lecture-name">Ders Adı: Öğrenci Danışman İlişki Süreci</td>
                </tr>
                <tr>
                    <td className="lecturer-name">Ders Verecek Öğretim Üyesi: Prof. Dr. Mustafa SÖZBİLİR</td>
                    <td className="lecturer-name">Ders Verecek Öğretim Üyesi: Arş. Gör. Osman DURDAĞ</td>
                </tr>
                <tr>
                    <td>
                        <ul>
                            <strong>Detaylı Ders İçeriği:</strong>
                            <li><FaAngleRight /> İyi bir ilişki için temel kurallar</li>
                            <li><FaAngleRight /> İletişimde engellerin kaldırılması</li>
                        </ul>
                    </td>
                    <td>
                        <ul>
                            <strong>Detaylı Ders İçeriği:</strong>
                            <li><FaAngleRight /> İyi bir ilişki için temel kurallar</li>
                            <li><FaAngleRight /> İletişimde engellerin kaldırılması</li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <th colSpan={4} className="long-row">Öğle Arası</th>
                </tr>
                <tr>
                    <td rowSpan={3} className="long-column">
                        <span className="lecture-no">1. DERS</span>
                        <br />
                        <span className="lecture-time">09:00 - 09:45</span>
                        <br />
                        <span className="lecture-hour-count">Ders Saati: 1</span>
                    </td>
                    <td className="lecture-name">Ders Adı: Öğrenci Danışman İlişki Süreci</td>
                    <td rowSpan={3} className="long-column">
                        <span className="lecture-no">1. DERS</span>
                        <br />
                        <span className="lecture-time">09:00 - 09:45</span>
                        <br />
                        <span className="lecture-hour-count">Ders Saati: 1</span>
                    </td>
                    <td className="lecture-name">Ders Adı: Öğrenci Danışman İlişki Süreci</td>
                </tr>
                <tr>
                    <td className="lecturer-name">Ders Verecek Öğretim Üyesi: Prof. Dr. Mustafa SÖZBİLİR</td>
                    <td className="lecturer-name">Ders Verecek Öğretim Üyesi: Arş. Gör. Osman DURDAĞ</td>
                </tr>
                <tr>
                    <td>
                        <ul>
                            <strong>Detaylı Ders İçeriği:</strong>
                            <li><FaAngleRight /> İyi bir ilişki için temel kurallar</li>
                            <li><FaAngleRight /> İletişimde engellerin kaldırılması</li>
                        </ul>
                    </td>
                    <td>
                        <ul>
                            <strong>Detaylı Ders İçeriği:</strong>
                            <li><FaAngleRight /> İyi bir ilişki için temel kurallar</li>
                            <li><FaAngleRight /> İletişimde engellerin kaldırılması</li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td rowSpan={3} className="long-column">
                        <span className="lecture-no">1. DERS</span>
                        <br />
                        <span className="lecture-time">09:00 - 09:45</span>
                        <br />
                        <span className="lecture-hour-count">Ders Saati: 1</span>
                    </td>
                    <td className="lecture-name">Ders Adı: Öğrenci Danışman İlişki Süreci</td>
                    <td rowSpan={3} className="long-column">
                        <span className="lecture-no">1. DERS</span>
                        <br />
                        <span className="lecture-time">09:00 - 09:45</span>
                        <br />
                        <span className="lecture-hour-count">Ders Saati: 1</span>
                    </td>
                    <td className="lecture-name">Ders Adı: Öğrenci Danışman İlişki Süreci</td>
                </tr>
                <tr>
                    <td className="lecturer-name">Ders Verecek Öğretim Üyesi: Prof. Dr. Mustafa SÖZBİLİR</td>
                    <td className="lecturer-name">Ders Verecek Öğretim Üyesi: Arş. Gör. Osman DURDAĞ</td>
                </tr>
                <tr>
                    <td>
                        <ul>
                            <strong>Detaylı Ders İçeriği:</strong>
                            <li><FaAngleRight /> İyi bir ilişki için temel kurallar</li>
                            <li><FaAngleRight /> İletişimde engellerin kaldırılması</li>
                        </ul>
                    </td>
                    <td>
                        <ul>
                            <strong>Detaylı Ders İçeriği:</strong>
                            <li><FaAngleRight /> İyi bir ilişki için temel kurallar</li>
                            <li><FaAngleRight /> İletişimde engellerin kaldırılması</li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td rowSpan={3} className="long-column">
                        <span className="lecture-no">1. DERS</span>
                        <br />
                        <span className="lecture-time">09:00 - 09:45</span>
                        <br />
                        <span className="lecture-hour-count">Ders Saati: 1</span>
                    </td>
                    <td className="lecture-name">Ders Adı: Öğrenci Danışman İlişki Süreci</td>
                    <td rowSpan={3} className="long-column">
                        <span className="lecture-no">1. DERS</span>
                        <br />
                        <span className="lecture-time">09:00 - 09:45</span>
                        <br />
                        <span className="lecture-hour-count">Ders Saati: 1</span>
                    </td>
                    <td className="lecture-name">Ders Adı: Öğrenci Danışman İlişki Süreci</td>
                </tr>
                <tr>
                    <td className="lecturer-name">Ders Verecek Öğretim Üyesi: Prof. Dr. Mustafa SÖZBİLİR</td>
                    <td className="lecturer-name">Ders Verecek Öğretim Üyesi: Arş. Gör. Osman DURDAĞ</td>
                </tr>
                <tr>
                    <td>
                        <ul>
                            <strong>Detaylı Ders İçeriği:</strong>
                            <li><FaAngleRight /> İyi bir ilişki için temel kurallar</li>
                            <li><FaAngleRight /> İletişimde engellerin kaldırılması</li>
                        </ul>
                    </td>
                    <td>
                        <ul>
                            <strong>Detaylı Ders İçeriği:</strong>
                            <li><FaAngleRight /> İyi bir ilişki için temel kurallar</li>
                            <li><FaAngleRight /> İletişimde engellerin kaldırılması</li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <th colSpan={2} className="long-row">Toplam Ders Sayısı: 7</th>
                    <th colSpan={2} className="long-row">Toplam Ders Sayısı: 7</th>
                </tr> */}
      </tbody>
    </table>
  );
};

export default EventProgram;
